import React from 'react';
import { useAppDispatch } from '../../../../redux/hooks';
import { sendMessage } from '../websocket.slice';

export const useSendWebsocketMessage = (socketRef: React.MutableRefObject<WebSocket | null>) => {
    const dispatch = useAppDispatch();

    const sendWebsocketMessage = (data: string) => {
        if (socketRef.current) {
            socketRef.current.send(data);
            dispatch(sendMessage(data));
        } else {
            console.error('WebSocket is not connected');
        }
    };

    return { sendWebsocketMessage };
};
